import React, { useState } from "react";
import { KeyRound, Save } from "lucide-react";
import { updateOperationPassword } from "../../services/settingsService";

export default function OperationPasswordSettings() {
  const [password, setPassword] = useState("");
  const [confirmation, setConfirmation] = useState("");
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");

  const save = async () => {
    if (!/^\d{8}$/.test(password)) return setMessage("Enter an 8-digit password.");
    if (password !== confirmation) return setMessage("The two passwords do not match.");
    setLoading(true);
    setMessage("");
    try {
      await updateOperationPassword(password);
      setPassword(""); setConfirmation("");
      setMessage("Operation password saved. Existing unlocks remain valid for up to 5 minutes.");
    } catch (error) { setMessage(error.message || "Unable to save the operation password.");
    } finally { setLoading(false); }
  };

  return <div className="admin-settings">
    <div className="admin-settings-header"><h1 className="admin-overview-title">Operation Password</h1><p className="admin-overview-subtitle">Protect Data Science note editing, deletion, AI capture, and PDF export.</p></div>
    <div className="admin-settings-section">
      <div className="admin-settings-section-header"><div className="admin-access-block-icon admin-access-icon--blue"><KeyRound size={18} /></div><div><h2 className="admin-card-title">Data Science Canvas</h2><p className="admin-overview-subtitle" style={{ marginTop: 2 }}>Set an 8-digit password. A successful unlock lasts 5 minutes.</p></div></div>
      <div className="admin-exam-pwd-row" style={{ flexWrap: "wrap" }}>
        <input className="admin-input" type="password" inputMode="numeric" maxLength={8} value={password} onChange={(e) => setPassword(e.target.value.replace(/\D/g, ""))} placeholder="New 8-digit password" aria-label="New operation password" />
        <input className="admin-input" type="password" inputMode="numeric" maxLength={8} value={confirmation} onChange={(e) => setConfirmation(e.target.value.replace(/\D/g, ""))} placeholder="Confirm password" aria-label="Confirm operation password" />
        <button className="admin-btn admin-btn--green" onClick={save} disabled={loading}><Save size={14} />{loading ? "Saving…" : "Save password"}</button>
      </div>
      {message && <p className="admin-access-hint" role="status">{message}</p>}
    </div>
  </div>;
}
